module.exports = __webpack_public_path__ + "static/media/Зверева М.Б. (ДУ).da880509.pdf";